import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'

/**
 * Gets the seller certificate.
 */
export const getSellerCertificate = factoryService(({ organizationCode, processType, purchaseMechanismId, bidID }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/socios-sociedades/proceso-socios-sociedades-utp/${purchaseMechanismId}/${processType}/${organizationCode}/${
      bidID ?? 0
    }`
  )
)

/**
 * Gets the seller certificate old.
 */
export const getSellerCertificateOld = factoryService(({ organizationCode, processType, purchaseMechanismId }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/socios-sociedades/proceso-socios-sociedades/${purchaseMechanismId}/${processType}/${organizationCode}`
  )
)

/**
 * Gets dates awarded.
 */
export const getDatesAwarded = factoryService(({ processType, purchaseMechanismId }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/socios-sociedades/fecha-adjudicacion/${processType}/${purchaseMechanismId}`
  )
)
